var map = {
	"./image6.jpeg": 972,
	"./image8.jpeg": 234,
	"./photo0.jpeg": 305,
	"./photo2.jpeg": 591,
	"./photo3.jpg": 815,
	"./photo4.jpeg": 869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;